module.exports = __webpack_public_path__ + "img/DD_rgb.80648420.svg";